import { observer } from 'mobx-react';
import React from 'react';
import { Section } from 'controls/react/layout/section';
import { FormEntryNew } from 'controls/react/form/formEntryNew';
import { AntInput } from 'controls/react/ant/antInput';
import { AntCheckbox } from 'controls/react/ant/antCheckbox';
import { i18n } from 'core/localization';
import { WidgetConfigurationProps } from 'controls/designer/features/widgets/widgetConfig';
import { TextWidgetConfig } from 'controls/designer/features/widgets/textWidget/types';
import { useStore } from 'core/react/useStore';
import { TextWidgetEditorStore } from 'controls/designer/features/widgets/textWidget/components/text-widget-editor/textWidgetEditorStore';

export const TextWidgetEditor = observer((props: WidgetConfigurationProps<TextWidgetConfig>) => {
	const store = useStore(() => new TextWidgetEditorStore(), {
		props: props,
	});

	if (!store.props) return null;

	return (
		<Section appearance={'none'} childrenPadding={true}>
			<Section title={i18n('General')} appearance={'frame-top-only'}>
				<FormEntryNew label={i18n('Title')} model={store.props.config} modelField={'title'}>
					<AntInput />
				</FormEntryNew>

				<FormEntryNew model={store.props.config} modelField={'hideHeader'}>
					<AntCheckbox>{i18n('Hide header')}</AntCheckbox>
				</FormEntryNew>
			</Section>

			<div ref={store.createTextEditor}></div>
		</Section>
	);
});
